import { IInputProps } from "@interfaces";
import { useController } from "react-hook-form";
import { Dropdown, DropdownProps } from "primereact/dropdown";

import { Field } from "../../field";

//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.

export interface IDropdownProps
  extends IInputProps,
    Omit<DropdownProps, "name" | "defaultValue"> {}

const $Dropdown = ({
  name,
  label,
  rules,
  disabled,
  helperText,
  defaultValue,
  disabledInput,
  fieldClassName,
  shouldUnregister,
  ...props
}: IDropdownProps) => {
  const { field, fieldState } = useController({
    name,
    rules,
    disabled,
    defaultValue,
    shouldUnregister,
  });

  return (
    <Field
      name={name}
      label={label}
      helperText={helperText}
      className={fieldClassName}
      isRequired={!!rules?.required}
    >
      <Dropdown
        {...field}
        {...props}
        disabled={disabledInput}
        invalid={fieldState.invalid}
        emptyMessage="No se encontraron opciones."
        onChange={(event) => {
          field.onChange(event);
          props.onChange?.(event);
        }}
      />
    </Field>
  );
};

export default $Dropdown;
